import {
  createMeal,
  CreateMealMutation,
  CreateMealMutationVariables,
  createMealRecipe,
  deleteMeal,
  DeleteMealMutation,
  DeleteMealMutationVariables,
  deleteMealRecipe,
  graphqlCall,
  MealRecipe,
  updateMeal,
  UpdateMealMutation,
  UpdateMealMutationVariables,
} from '@akin-home/amplify';

export const updateMealMutation = (params: UpdateMealMutationVariables) =>
  graphqlCall<UpdateMealMutation>(updateMeal, params);

export const createMealMutation = (params: CreateMealMutationVariables) =>
  graphqlCall<CreateMealMutation>(createMeal, params);

export const deleteMealMutation = (params: DeleteMealMutationVariables) =>
  graphqlCall<DeleteMealMutation>(deleteMeal, params);

export const createMealRecipeLink = async (
  mealID: string,
  recipeID: string
): Promise<MealRecipe> => {
  return (await graphqlCall(createMealRecipe, { input: { mealID, recipeID } }))
    .data.createMealRecipe;
};

export const deleteMealRecipeLink = async (id: string) =>
  graphqlCall(deleteMealRecipe, { input: { id } });
